if (ISDEBUG) { console.log("index.js: Top of file"); };

import * as S from 'sanctuary';
import * as SD from 'sanctuary-def';
import DOMPurify from 'dompurify';

import './main.css';
import { Elm } from './Main.elm';
import * as serviceWorker from './serviceWorker';

import { getDataServiceFn } from './DataService';

import { INTEROP_TAGS } from './JsInterop/Constants'

import { handleRefreshIfAlreadyAuthenticated } from './JsInterop/SignInOut'

//Import GraphQL operations
import { teachers, students, studentsByTchId } from 'sm-nap-onl-shared/queries'
import { updateTeacher, updateStudent, deleteEntity, updateLoginUser, createTeacher, createStudent, deleteLoginUser, createEntity, deleteStudentHistory } from 'sm-nap-onl-shared/mutations'
import { me, bySId, nbrUsersForSchoolId, studentsWithHstry, studentsByTchIdWithHstry, createQuestionGroup, updateStudentRespondWithIdOnly } from './JsInterop/customGraphQLQueries'

//d3 analytics and graphs
import { subscribeAnalyticsPortFunctions } from './analytics/analytics';


// Required here to be included in build by webpack
import 'font-awesome/css/font-awesome.css';
import 'bulma/css/bulma.css';
import 'bulma-accordion/dist/css/bulma-accordion.min.css';
import 'bulma-tooltip/dist/css/bulma-tooltip.min.css';
import './smia-styles.css';
//var intro = require('intro.js/minified/intro.min.js');
import 'intro.js/minified/introjs.min.css';

//var AWS = require('aws-sdk');
import $ from "jquery";

//2020-03-06 as per https://github.com/aws/aws-sdk-js/issues/399
// AWS.config.update({
//     correctClockSkew: true,
//   });

import CryptoJS from "crypto-js";


if (ISDEBUG) { window.LOG_LEVEL = 'DEBUG' }

//import Amplify from 'aws-amplify';
//import '@aws-amplify/cache';
//import awsconfig from 'AWS_EXPORTS';
// see https://stackoverflow.com/questions/36367532/how-can-i-conditionally-import-an-es6-module for: const awsconfig = if etc.. require('prodxxx') else require ("staging");
import awsconfig from './aws-exports';
import { Auth } from '@aws-amplify/auth';
import { API } from '@aws-amplify/api';
//import Storage  from '@aws-amplify/storage';

//Amplify.configure(awsconfig);
API.configure(awsconfig); // v4 still needs this
Auth.configure(awsconfig); // v4 still needs this

//import custom elements as per https://guide.elm-lang.org/interop/custom_elements.html 
// EXAMPLE Not used as at 2023-04-02
//import { schoolEditor } from './customElements/schoolEditor';





//var introguide = intro.introJs();

// mjd 2017-08-15 helper to render mathjax *** only used if refresh url - No longer needed, since mathJaxTypeset () port is called after retrieving each and every post
// require('./SMMathJaxHelper.js'); //NOT USED as at 2017-09-22


// Require index.html so it gets copied to dist
//2019-10-22 require('./index.html');

const SESSION_HAS_LOGGED_IN_FLAG = "1";
//const SESSION_CREDENTIALS_STR = "sessionCredentials";
const SESSION_STATE_STR = "2";
//const SESSION_ALREADY_RETRIED_LOGIN = "3";

//const serverEnv = (awsconfig.aws_appsync_graphqlEndpoint == "https://pj5jlhp74jdx5fds6ehxrfbwbu.appsync-api.ap-southeast-2.amazonaws.com/graphql") ? "prod" : "staging"
const serverEnv = (awsconfig.aws_appsync_graphqlEndpoint == "https://vug2iyxe7vbpboppbn3mct6zyi.appsync-api.ap-southeast-2.amazonaws.com/graphql") ? "prod" : "staging"



let app = Elm.Main.init({
    node: document.getElementById('app'),
    flags: {
        urlPrefixAppCfg: URLPREFIX_APPCFG,
        urlPrefixClientResources: URLPREFIX_CLIENT_RESOURCES,
        urlPosts: URL_POSTS,
        //loginUrl: "https://" + AWS_AppWebDomain + "/login?response_type=token&client_id=" + AWS_ClientId + "&redirect_uri=" + AWS_RedirectUriSignIn,
        version: VERSION,
        isDebug: ISDEBUG,
        serverEnv: serverEnv,
        //maxDiffRefreshMins: MAX_DIFF_REFRESH_MINS,
        initUrl: location.href, // as per https://github.com/elm/browser/blob/master/notes/navigation-in-elements.md
        // interopTagsJTE: S.values (INTEROP_TAGS.JTE),
        // interopTagsETJ: S.values (INTEROP_TAGS.ETJ)
        interopTags: S.values(INTEROP_TAGS),
        graphQLOps: {
            meGQL: me,
            teachersGQL: teachers,
            studentsGQL: students,
            studentsWithHstryGQL: studentsWithHstry,
            bySIdGQL: bySId,
            nbrUsersForSchoolIdGQL: nbrUsersForSchoolId,
            studentsByTchIdGQL: studentsByTchId,
            studentsByTchIdWithHstryGQL: studentsByTchIdWithHstry,
            updateTeacherGQL: updateTeacher,
            updateStudentGQL: updateStudent,
            updateStudentRespondWithIdOnlyGQL: updateStudentRespondWithIdOnly,
            updateLoginUserGQL: updateLoginUser,
            deleteLoginUserGQL: deleteLoginUser,
            deleteStudentHistoryGQL: deleteStudentHistory,
            createTeacherGQL: createTeacher,
            createStudentGQL: createStudent,
            createEntityGQL: createEntity,
            deleteSchoolGQL: deleteEntity,
            createQuestionGroupGQL: createQuestionGroup,

        }
    }
});


if (ISDEBUG) { console.log("app is now:", app); }



// Added for AWS Amplify NAPLAN Online version 2 as at 2019-11-26
import { initNapOnlBackendAccess } from './JsInterop/NapOnlBackendAccess';
initNapOnlBackendAccess(app);


import { handleGraphQLMsgsReceivedFromElm } from './JsInterop/GraphQL';
// const sendToElm2 = tag => payload => app.ports.infoForElm.send({tag: tag, payload: payload })
app.ports.infoForGraphQL.subscribe(msg => handleGraphQLMsgsReceivedFromElm(app.ports.infoForElm)(msg));


//2020-03-13 for new post access
const decryptPostContent = (ciphertext) => {

    const bytes = CryptoJS.AES.decrypt(ciphertext, String.fromCharCode(51) + '794826783725' + String.fromCharCode(54));
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    //console.log(originalText); // 'my message'
    app.ports.onDecodeContent.send(originalText);
    //return originalText;
}

app.ports.decodeContent.subscribe(decryptPostContent);




// 2019-10-23 from https://github.com/elm/browser/blob/1.0.0/notes/navigation-in-elements.md
// var app = Elm.Main.init({
//     flags: location.href,
//     node: document.getElementById('elm-main')
// });

// Inform app of browser navigation (the BACK and FORWARD buttons)
// document.addEventListener("popstate", function () {
//     if (ISDEBUG) { console.log("location from popstate is: ", location); }
//     app.ports.onUrlChange.send(location.href);
// });


window.onpopstate = function(event) {
    //alert("location: " + document.location + ", state: " + JSON.stringify(event.state));

    if (ISDEBUG) { console.log("window.onpopstate: location: ", location); }
    if (ISDEBUG) { console.log("window.onpopstate: document.referrer: ", document.referrer); }
    if (ISDEBUG) { console.log("window.onpopstate: event: ", event); }

    //if (document.referrer.includes('sm_showVariant')) {
    if (event.state && event.state.url && event.state.url.includes('sm_showVariant')) {
        // Note, this allows a single back in an exam since the StartActivity for showVariant pushes two sm_showVariant's to the pushState, so
        // the first one is passed onpopstate! (since the most recent one is already popped!)
        window.alert("\nSmarterMaths Warning!\n\nYou should not click back at this time.\n\nPlease click 'Home' instead (if it is visible), or if you really want to discard your work, click back again, or close the browser/tab.")
        // event.stopImmediatePropagation()
        // let url = location.origin + "/sm_showVariant"
        // history.pushState({url: url}, '', url);    
    } else {
        app.ports.onUrlChange.send(location.href);
    }
};


// Bound to window so can be called from within analytics/ByBand.js D3 document
window.pushUrl = function(url) {
    //Moving from elm 0.18 to elm 0.19 state was not used, so is currently left blank here as at 2019-10-24, but could now be used in future.
    history.pushState({ url: url }, '', url);
    if (ISDEBUG) { console.log("pushUrl received with:", url); }
    if (ISDEBUG) { console.log("pushUrl location.href is::", location.href); }
    app.ports.onUrlChange.send(location.href);
}


// Change the URL upon request, inform app of the change.
app.ports.pushUrl.subscribe(window.pushUrl);

// Make the browser go back
app.ports.browserBack.subscribe(function() {
    //Moving from elm 0.18 to elm 0.19 state was not used, so is currently left blank here as at 2019-10-24, but could now be used in future.
    history.back();
    if (ISDEBUG) { console.log("browserBack received"); }
    //Note: back will cause onpopstate to fire which will send: app.ports.onUrlChange.send(location.href); so DON'T do it here!
});



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

let userSub;
let s3;
let docClient;

//AWS.config.region = AWS_Region;

let sendGetHiddenExamGroups;
let sendPutHiddenExamGroups;
let sendDeleteHiddenExamGroups;

//Setup all analytics port functions
subscribeAnalyticsPortFunctions(app);

if (ISDEBUG) { console.log("index.js: After subscribeAnalyticsPortFunctions()"); };


const setupPortFunctions = (s3, docClient, apigClient) => {
    if (ISDEBUG) { console.log("🔍 Setting up port functions with API Gateway SDK usage monitoring..."); }
    // Wrap functions with logging to track API Gateway SDK usage (only in debug mode)
    const originalSendGetHiddenExamGroups = getDataServiceFn($, app, s3, docClient, userSub, apigClient, "sendGetHiddenExamGroups");
    sendGetHiddenExamGroups = (...args) => {
        if (ISDEBUG) {
            console.warn("🔍 API Gateway SDK function called: sendGetHiddenExamGroups", args);
            console.trace("sendGetHiddenExamGroups call stack:");
        }
        return originalSendGetHiddenExamGroups(...args);
    };
    
    const originalSendPutHiddenExamGroups = getDataServiceFn($, app, s3, docClient, userSub, apigClient, "sendPutHiddenExamGroups");
    sendPutHiddenExamGroups = (...args) => {
        if (ISDEBUG) {
            console.warn("🔍 API Gateway SDK function called: sendPutHiddenExamGroups", args);
            console.trace("sendPutHiddenExamGroups call stack:");
        }
        return originalSendPutHiddenExamGroups(...args);
    };
    
    const originalSendDeleteHiddenExamGroups = getDataServiceFn($, app, s3, docClient, userSub, apigClient, "sendDeleteHiddenExamGroups");
    sendDeleteHiddenExamGroups = (...args) => {
        if (ISDEBUG) {
            console.warn("🔍 API Gateway SDK function called: sendDeleteHiddenExamGroups", args);
            console.trace("sendDeleteHiddenExamGroups call stack:");
        }
        return originalSendDeleteHiddenExamGroups(...args);
    };
};

const subscribePortFunctions = () => {
    app.ports.sendGetHiddenExamGroups.subscribe(sendGetHiddenExamGroups);
    app.ports.sendPutHiddenExamGroups.subscribe(sendPutHiddenExamGroups);
    app.ports.sendDeleteHiddenExamGroups.subscribe(sendDeleteHiddenExamGroups);
};

const unsubscribePortFunctions = () => {
    app.ports.sendGetHiddenExamGroups.unsubscribe(sendGetHiddenExamGroups);
    app.ports.sendPutHiddenExamGroups.unsubscribe(sendPutHiddenExamGroups);
    app.ports.sendDeleteHiddenExamGroups.unsubscribe(sendDeleteHiddenExamGroups);
};

const logout = () => {
    // console.log("about to auth.signOut()");
    clearSessionStorage();
    Auth.signOut();
    // AWS SDK v2 credentials cleanup removed - using AWS Amplify v3 instead
};


const clearSessionStorage = (possibleItem) => {
    if (typeof (Storage) !== "undefined") {
        if (ISDEBUG) { console.log("clearSessionStorage") };

        if (possibleItem) {
            sessionStorage.removeItem(possibleItem);
        } else {
            sessionStorage.removeItem(SESSION_HAS_LOGGED_IN_FLAG);
            sessionStorage.removeItem(SESSION_STATE_STR);
        }
    }
}

const setSessionStorage = (tokenName, dataToStore) => {
    if (typeof (Storage) !== "undefined") {
        if (ISDEBUG) { console.log("tokenName", tokenName, "dataToStore", dataToStore) }

        //encrypt dataToStore before storing it
        const encryptedDataToStore = CryptoJS.AES.encrypt(JSON.stringify(dataToStore), '79245');

        sessionStorage[tokenName] = encryptedDataToStore.toString();
    }
}

const getSessionStorage = (tokenName) => {
    let retVal = null;

    if ((typeof (Storage) !== "undefined") && sessionStorage[tokenName]) {

        // retrieve encrypted dataFromStore
        const encryptedDataFromStore = sessionStorage[tokenName];

        try {
            // Decrypt
            const bytes = CryptoJS.AES.decrypt(encryptedDataFromStore, '79245');
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

            if (ISDEBUG) { console.log("getSessionStorage for tokenName", tokenName, decryptedData) };

            retVal = decryptedData;
        } catch (err) {
            console.log("index.js: Error: could not decrypt session storage so supressing error, clearing storage, and returning nothing from storage. Err was:", err);
            clearSessionStorage();
        }
    }

    return retVal;
}


let auth;


// mjd 2017-09-22
// require('./SMQuestionAnswerHelper.js');
// 2017-09-22 Use delegated jquery events (see http://api.jquery.com/on/) to attach event handler to answer options after post content is rendered
// Note: the outer $(abc) runs once after page load for an SPA without refreshes as per https://api.jquery.com/ready/
// *******************
// index.js is included by webpack.config.common.js and this is the entrypoint of the entire application
$(
    (() => {

        const sendToElm = tag => payload => {
            // {tag: INTEROP_TAG.JTE.xyz, payload: ... }
            app.ports.infoForElm.send({ tag: tag, payload: payload });
        }

        //Auth.currentCredentials().then( credsSuccess(sendPutHiddenExamGroupsFn), credsFailure("XXX: failed creds"));
        //Auth.currentUserInfo().then(user => console.log("User INFO is:", user), e => console.log("user info failure:", e));
        //Auth.currentCredentials().then( ((el) => console.log("AAA: Succeeded Creds", el)), (() => console.log("XXX: Failed Creds")));	
        handleRefreshIfAlreadyAuthenticated(sendToElm);


        const sessionState = getSessionStorage(SESSION_STATE_STR);
        if (sessionState) {
            if (ISDEBUG) { console.log("index.js: $(): sessionState", sessionState); };
            app.ports.onRetrievePartialModelState.send(sessionState);
        }



    })(),

    // Using key == "Enter" as per https://stackoverflow.com/questions/12955222/how-to-trigger-html-button-when-you-press-enter-in-textbox/24245592#24245592
    $(":root").on("keyup", event => {
        //if (ISDEBUG) { console.log("index.js: $(): Keyup event in the document (:root)"); };
        //console.log("A key was pressed");
        if (event.key == "Enter") {
            if ($("#sm-btn-next-qstn").length) {
                //console.log("Send next question event");
                app.ports.onActionTriggerRequest.send({ action: "ShowNextQuestion" });
            }
        }
    }),

    $("#main").on("click", ".sm-a-option", function() {
        let clickedOption = $(this);
        // console.log("clickedOption is: ", clickedOption);

        let clickedOptionElement = clickedOption[0];
        let allOptions = $(".sm-a-option");
        // var previouslySelected = jQuery(".sm-a-selected");
        // var previouslySelectedOptionIdx = null;

        // calculate the index of this element
        let clickedOptionIdx = allOptions.toArray().indexOf(clickedOptionElement);

        //smpid is the postId
        //let postId = $('#smpid').getAttribute("data-smpid"); <- use this in the browser console
        let postId = $('#smpid').attr("data-smpid");

        //Create the secret "83566" in a weak way!
        let s = String.fromCharCode(56) + String.fromCharCode(51) + "56" + String.fromCharCode(54);

        //c is the classname of the correct answer
        // mjd 2025-08-06 snyk-code ignore with below comment line
        // deepcode ignore InsecureHash: SHA1 is sufficient for non-cryptographic obfuscation of CSS class names
        let c = "_" + CryptoJS.HmacSHA1(postId, s).toString();

        //app.ports.receiveMCIsAnswerCorrect.send([clickedOptionIdx, clickedOption.hasClass("sm-a-correct")]);
        app.ports.receiveMCIsAnswerCorrect.send([clickedOptionIdx, clickedOption.hasClass(c)]);
    }),

    $("#main").on("keypress", ".sm-red-box-a", function(ev) {
        //FILTER the keys able to be pressed in a sm-red-box-a
        //0-9 or . or -
        //See also update.elm filtering of expectedVal_
        //from https://stackoverflow.com/questions/469357/html-text-input-allows-only-numeric-input
        return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 45 && event.charCode <= 46));
    }),

    $("#main").on("keyup", ".sm-red-box-a", function(ev) {

        // console.log('An .sm-red-box was typed into, and val is now: ', ev.target.value);

        //Assess if result is correct or not (answer is embedded in html)
        // var isCorrect = true;
        // console.log(ev);
        app.ports.receiveStringIsAnswerCorrect.send(ev.target.value);

    })
);


//mjd 2017-09-22 for mathJax typesetting after content has been rendered for each specific question
app.ports.mathJaxTypeset.subscribe(function() {
    // setTimeout(function() { MathJax.Hub.Queue(["Typeset", MathJax.Hub]); }, 100);

    // let checkExist2 = setInterval(function() {
    //     console.log("not yet");
    //     if ($('.katex').length) {
    //         renderMathInElement(document.body);
    //         //clearInterval(checkExist2);
    //     }
    // }, 1000); // check every x milliseconds

    let checkExist = setInterval(function() {
        // console.log("not yet");
        if ($('.sm-mjax').length) {
            MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
            clearInterval(checkExist);
        }
    }, 20); // check every x milliseconds
});

app.ports.sendStorePartialModelState.subscribe(function(partialModelState) {
    if (ISDEBUG) { console.log("index.js: sendStorePartialModelState function with partialModelState of: ", partialModelState); };
    setSessionStorage(SESSION_STATE_STR, partialModelState);
});

//2019-10-23 commented out since probably not used?
// app.ports.sendClearPartialModelState.subscribe(function() {
//     if(ISDEBUG) { console.log("index.js: sendClearPartialModelState function"); };
//     clearSessionStorage (SESSION_STATE_STR);

// });


app.ports.sendRefreshCredentials.subscribe(function() {
    // console.log("about to sendRefreshCredentials()")
    // retrieveCredentials();
    // setupAWS();
    // AWS.config.credentials.clearCachedId()
    // initCognitoSDK();

    // setupAWS();
    //refreshCredentials();

    // console.log("after sendRefreshCredentials()")
});


// *******************************************
//
// Svg encoding for elm consumption and decoding in localElmPackages/html-parser/src/Html/Parser/Util.elm
//
// *******************************************
const encodeSvg = (svgString) => {
    let retVal = document.createElement("p")
    retVal.className = "smsvg"
    retVal.innerText = btoa(svgString)
    return retVal
}

//Recusive
const processChildrenForSvg = (el) => {
    for (let i = 0; i < el.children.length; i++) {
        if (el.children[i].tagName === "svg") {
            el.replaceChild(encodeSvg(el.children[i].outerHTML), el.children[i])
        } else {
            el.replaceChild(processChildrenForSvg(el.children[i]), el.children[i])
        }
    }
    return el
}

// encodeSmSvg : String -> String
// encodeSmSvg "<p>...</p>" == "<p>...</p>"
// encodeSmSvg "<svg>...</svg>" == "<p class=''>...</p>"
const encodeSmSvg = (content) => {
    //if this string version of the node starts with <svg, then transform it for elm consumption
    // we createElement as a div and set it's innerHTML then return the innerHTML to use the parsing capabilities of createElement
    if (content.includes("<svg")) {
        const el = document.createElement('div');
        // Sanitize content with DOMPurify before setting innerHTML to prevent XSS
        const sanitized = DOMPurify.sanitize(content, {
            ADD_TAGS: ['svg', 'g', 'path', 'circle', 'rect', 'line', 'polyline', 'polygon', 'ellipse', 'text', 'tspan', 'defs', 'clipPath', 'linearGradient', 'radialGradient', 'stop', 'use', 'symbol', 'marker', 'pattern', 'mask', 'filter', 'feGaussianBlur', 'feColorMatrix', 'feOffset', 'feMerge', 'feMergeNode'],
            ADD_ATTR: ['viewBox', 'width', 'height', 'x', 'y', 'cx', 'cy', 'r', 'rx', 'ry', 'd', 'points', 'fill', 'stroke', 'stroke-width', 'stroke-linecap', 'stroke-linejoin', 'stroke-dasharray', 'transform', 'opacity', 'fill-opacity', 'stroke-opacity', 'font-size', 'font-family', 'text-anchor', 'clip-path', 'mask', 'filter', 'gradientTransform', 'gradientUnits', 'offset', 'stop-color', 'stop-opacity', 'href', 'xlink:href', 'id', 'class', 'style', 'preserveAspectRatio', 'patternUnits', 'patternTransform', 'markerWidth', 'markerHeight', 'markerUnits', 'refX', 'refY', 'orient', 'stdDeviation', 'in', 'result', 'values', 'type']
        });
        el.innerHTML = sanitized;
        let processedContent = processChildrenForSvg(el)
        return processedContent.innerHTML
    } else {
        return content
    }

}


const makeSmSvgAnswers = qType => aSet => {
    const updateAnswers = (aSet_) => {
        return aSet_.map(
            el => {
                let retVal_ = el
                retVal_.answer = encodeSmSvg(el.answer)
                return retVal_
            }
        )
    }

    //Note: Not needed for Answer Box qType as of 2021-07-08
    const isToApplyInlineSvgPatch = qType_ => S.or(S.equals(qType_)("Multiple Choice (One Answer)"))(S.equals(qType_)("Multiple Choice (Multiple Answer)"))
    return (isToApplyInlineSvgPatch(qType)) ? updateAnswers(aSet) : aSet
}


//Setup generic decrypt ports used in new minstd course as at 2020-09-17
app.ports.sendDecryptItem.subscribe(function(decryptRequest) {

    //See src/Type/Decrypt.elm for types
    //if (ISDEBUG) { console.log("decryptRequest is", decryptRequest) }

    const bytes = CryptoJS.AES.decrypt(decryptRequest.ciphertext, decryptRequest.key);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    //const cleartext = JSON.parse(originalText);
    const decryptedObj = JSON.parse(originalText);

    if (ISDEBUG) { console.log("index.js: raw decryptedObj (before SmSvg parsing)", JSON.stringify(decryptedObj)) }

    //added 2021-05-11 to handle inline svg encoding for future chemistry and katex mchem elements
    decryptedObj.qContent = encodeSmSvg(decryptedObj.qContent)
    decryptedObj.wsContent = encodeSmSvg(decryptedObj.wsContent)

    decryptedObj.aSet = makeSmSvgAnswers(decryptedObj.qType)(decryptedObj.aSet)

    if (ISDEBUG) { console.log("index.js: about to reply to app.ports.onDecryptItemResponse", JSON.stringify(decryptedObj)) }

    app.ports.onDecryptItemResponse.send({ contentTag: decryptRequest.contentTag, responseHandler: decryptRequest.responseHandler, decrypted: decryptedObj });
});


//setupPortFunctions(s3, docClient, apigClient);
// Leave apigClient for lambda access unimplemented as at v2 2020-03-04 and will re-implement school name for google analytics later
setupPortFunctions(null, null, null);
subscribePortFunctions();

